<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";

import CustomersApi from "@/services/customers-api";
import CountriesApi from "@/services/countries-api";

/**
 * Contacts-grid component
 */
export default {
  page: {
    title: "Les contacts",
    meta: [{ name: "description", content: appConfig.description }]
  },
  mounted(){
      this.getCustomers();
      this.getCities();
      this.getDirectories()
    },
  components: { Layout },
  data() {
    return {
      customerList:[],
      selectedCustomer:null,
      citiesList:[],
      selectedCity:null,
      customerGridData:[],
      pageMain: {currentPage : 1, perPage : 8, totalRows: 0},
      isTableBusy:false,
  
    };
  },
  methods: {
    getCustomers(){
      CustomersApi.getActiveCustomers().then(
        result =>{
          this.customerList=result;
        }
      )
    },
    getCities(){
      CountriesApi.getCurrentCustomerCities().then(
          result => {
            this.citiesList = result
        })
    },

    getDirectories(){
      this.isTableBusy = true;
      CustomersApi.getDirectories(this.pageMain.currentPage, this.pageMain.perPage,this.selectedCustomer != null ? this.selectedCustomer.id: null , this.selectedCity != null ? this.selectedCity.id : null ).then(
        result =>{
            this.customerGridData = result.list
            this.pageMain.totalRows = result.total;
            this.pageMain.currentPage = result.page;
            this.pageMain.perPage = result.pageSize;
            this.pageMain.pageSize = result.pageSize;
        }
      ).finally(() => {
        this.isTableBusy = false;
      })
    }
  },

  watch : {
    selectedCustomer : function(){
      this.getDirectories()
    },

    selectedCity : function(){
      this.getDirectories()
    },
  }

  
};
</script>

<style>
.truncate-title {
  white-space: nowrap; 
  width: 100% ;
  overflow: hidden;
  text-overflow: ellipsis; 
}
</style>

<template>
  <Layout>

    <div class="row  pt-4 ">

      <div class="col-lg-12">
        <div class="card border">
          <div class="card-body">
            <h2 class="card-title " style="font-size:2em;">Annuaire des Adhérents du Groupement</h2>
            <p class="card-title-desc ">
              La liste des officinaux membres du groupement pharmaceutique.
            </p>

              <div class="row mt-2">
                  <div class="col-sm-4 col-xs-6">
                    <v-select class="style-vselect" :options="customerList" v-model="selectedCustomer"  placeholder="Chercher par officine" label="name" >
                      <span slot="no-options">Aucun élément dans la liste</span>
                    </v-select> 
                  </div>
                  <div class="col-sm-4 col-xs-0"/>
                    <div class="col-sm-4 col-xs-12">
                      <v-select class="style-vselect" :options="citiesList" v-model="selectedCity" placeholder="Chercher par Ville" label="name"  >
                        <span slot="no-options">Aucun élément dans la liste</span>
                      </v-select>
                    </div>
                </div>
          </div>
        </div>
      </div>
    </div>

<div class="card border border-light mt-4 " style="min-height:48em">
    <div class="row p-4" style="min-height:20em">
      <div v-for="user in customerGridData" :key="user.id" class="col-xl-3 col-sm-6 p-4" >
        
        <div class="card h-100  border border-light" style="border: 0.15em solid #297a54; background-color:#f9f9f9;">
          <div class="card-body m-2 " >

            <div class="row">
              <div class="col-12">
                <h5 class="text-primary text-center font-weight-bold">{{user.name}}</h5>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-12">
              <h5 class="text-dark text-center font-size-14"><i>{{user.city}}, {{user.country}} </i></h5>
              </div>
            </div>

            <div class="row mt-4"/>

            <div class="row mt-4">
              <div class="col-12">
                <span :class="user.phone ? 'text-dark font-weight-bold' : 'text-muted'" style="text-align:justify"> <i class="fas fa-phone text-primary mr-2" />{{user.phone ? user.phone : '## ### ###'}}</span>
              </div>
            </div>

            <div class="row mt-2">
              <div class="col-12">
                <span :class="user.secondPhone ? 'text-dark font-weight-bold' : 'text-muted'" style="text-align:justify"> <i class="fas fa-phone text-white mr-2" />{{user.secondPhone ? user.secondPhone : '## ### ###'}} </span>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-12">
                <span :class="user.mail ? 'text-dark font-weight-bold' : 'text-muted'" style="text-align:justify"><i class="far fa-envelope text-primary mr-2"/><i>{{user.mail ? user.mail : 'Pas d\'email'}}</i></span>
              </div>

            </div>
            

            <div class="row mt-2">
              <div class="col-12">
                <p :class="user.address == null || user.address.trim().length == 0 ? 'text-muted' : 'text-dark'" style="text-align:justify"><i class="fas fa-map-marker-alt text-primary mr-2"/><i>{{ user.address == null || user.address.trim().length == 0 ? 'Pas d\'adresse' : user.address}}</i></p>
              </div>
            </div>

          <div>
              
        </div>

            <!-- <span class="font-size-14 mb-2">
              <a href="javascript: void(0);" class="text-muted font-size-14"><i>{{user.city}}, {{user.country}} </i></a>
            </span> -->

            <!-- <p class="text-muted" style="text-align:justify"><strong>Adresse : </strong> {{user.address}} </p>

             <p class="text-muted" style="text-align:justify"> <i class="fas fa-phone-square mr-2" />{{user.phone}}<span v-if="user.secondPhone"><i class="fas fa-phone-square ml-2 mr-2" />{{user.secondPhone}}</span></p>

             <p class="text-muted" style="text-align:justify"> <i class="far fa-envelope mr-2"/> {{user.mail}}  </p>
            <div>
              
            </div>-->
          </div> 
          
        </div>
      </div>

      <!-- end col -->
    </div>
</div>
          <div v-if="isTableBusy" class="d-flex justify-content-center">
          <div class="spinner-border text-success" role="status">
              <span class=" sr-only">Chargement...</span>
          </div>
      </div>
      <span v-if="!isTableBusy && !customerGridData.length" class="d-flex justify-content-center  text-danger" >Aucune Pharmacie dans la liste</span>

    <!-- Pagination -->
    <div class="row p-4 mb-sm-4">
        <div class="col-sm-8">
            <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                <b-form-select @input="getDirectories()"  v-model="pageMain.perPage" size="sm" style="width: 5em" :options="[8,12,16,20]"></b-form-select>
                <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur</span><span class="font-weight-bold"> {{pageMain.totalRows}} lignes</span></div>
            </div>
        </div>
        <div class="col-sm-4">
            <div class="dataTables_paginate paging_simple_numbers float-right">
                <ul class="pagination pagination-rounded mb-0">
                <b-pagination v-model="pageMain.currentPage" :disabled="isTableBusy" :per-page="pageMain.pageSize" :total-rows="pageMain.totalRows" @input="getDirectories()" ></b-pagination>
                </ul>
            </div>
        </div>
    </div> 
    <!-- Fin Pagination  -->
  </Layout>
</template>